module.exports = __webpack_public_path__ + "static/media/surface-3.466b64f1.png";